import { render } from "./AppTopbar.vue?vue&type=template&id=cbba145a"
import script from "./AppTopbar.vue?vue&type=script&lang=ts"
export * from "./AppTopbar.vue?vue&type=script&lang=ts"
script.render = render

export default script